import { createSlice } from "@reduxjs/toolkit"

const initialStateFiltrosJuicios = {
  nroJuicio: "",
  fechaNotificacionInicio: "",
  fechaNotificacionFin: "",
  nroSiniestro: "",
  textoBusqueda: "",
  nroRaj: "",
  cuitLetrado: -1,
  idEstadoJuicio: -1,
  cargados: false,
  filtroRapido: ""
};

export const filtroJuiciosSlice = createSlice({
  name: "filtroJuicios",
  initialState: initialStateFiltrosJuicios,
  reducers: {
    addFiltrosJuicio: (state, action) => {
      const { nroJuicio, fechaNotificacionInicio, fechaNotificacionFin, nroSiniestro, textoBusqueda, nroRaj, cuitLetrado, idEstadoJuicio  } = action.payload
      state.nroJuicio = nroJuicio
      state.fechaNotificacionInicio = fechaNotificacionInicio
      state.fechaNotificacionFin = fechaNotificacionFin
      state.nroSiniestro = nroSiniestro
      state.textoBusqueda = textoBusqueda
      state.nroRaj = nroRaj
      state.idEstadoJuicio = idEstadoJuicio
      state.cuitLetrado = cuitLetrado
    },
    resetFiltrosJuicio: (state) => {
      state.nroJuicio = initialStateFiltrosJuicios.nroJuicio
      state.fechaNotificacionInicio = initialStateFiltrosJuicios.fechaNotificacionInicio
      state.fechaNotificacionFin = initialStateFiltrosJuicios.fechaNotificacionFin
      state.textoBusqueda = initialStateFiltrosJuicios.textoBusqueda
      state.nroRaj = initialStateFiltrosJuicios.nroRaj
      state.nroSiniestro = initialStateFiltrosJuicios.nroSiniestro
      state.idEstadoJuicio = initialStateFiltrosJuicios.idEstadoJuicio
      state.cuitLetrado = initialStateFiltrosJuicios.cuitLetrado
      state.cargados = initialStateFiltrosJuicios.cargados
      state.filtroRapido = initialStateFiltrosJuicios.filtroRapido
    },
    setFiltrosCargados: (state, action) => {
      state.cargados = action.payload
    },
    addFiltroRapidoJuicio: (state, action) => {
      state.filtroRapido = action.payload
    },
  }
});

export const { addFiltroRapidoJuicio, resetFiltrosJuicio, setFiltrosCargados, addFiltrosJuicio } = filtroJuiciosSlice.actions
export default filtroJuiciosSlice.reducer
